import {
  IContact,
  IUserSuite,
} from 'src/services/api/ServiceRequestDashboard/apiContracts';

export interface IContactTableRow extends IContact {
  suiteName: string | null;
}

export const transformContactData = (data: IContact[]): IContactTableRow[] => {
  return data.map((contact: IContact): IContactTableRow => {
    const { ...rest } = contact;

    // Early return if userSuites is already a string (like "N/A").
    if (typeof contact.userSuites === 'string') {
      return {
        ...rest,
        suiteName: contact.userSuites,
      };
    }

    // Handle array case.
    const suiteName: string =
      contact.userSuites?.map((suite) => suite.suiteName).join(', ') || 'N/A';

    return {
      ...rest,
      suiteName,
    };
  });
};
